import globals from "@/util/global-whitelist.mjs";

// resolves then the client has an active internet connection
export default function clientOnline(timeout = 3000): Promise<void> {
  // trivial case
  if (
    typeof globals.navigator?.onLine !== "boolean" ||
    globals.navigator.onLine
  )
    return Promise.resolve();

  return new Promise((resolve) => {
    const cb = () => {
      clearTimeout(t);
      globals.removeEventListener("online", cb);
      resolve();
    };
    const t = setTimeout(cb, timeout);
    globals.addEventListener("online", cb, {
      once: true,
      passive: true,
    });
  });
}
